import { html, LitElement } from 'lit';
import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import '@cof/fs-button-wc/fs-button.js';
import '@cof/fs-typography-wc/fs-heading.js';
import '@cof/fs-typography-wc/fs-body-text.js';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { style } from './refi-error.style.js';
import { DebugService } from '../../shared/services/debug.service.js';
import { stratum } from '../../../constants/stratum.js';

class RefiError extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('ErrorComponent');
  }

  static get styles() {
    return [style];
  }

  firstUpdated() {
    stratum.publishTag(TagKey.VIEW_PERSONAL_SNAG_PAGE);
  }

  render() {
    return html`
      <div class="refi-error-container">
        <fs-heading size="large">Looks like we hit a snag</fs-heading>
        <fs-body-text size="normal"
          >We're having trouble processing your request. Please come back and
          try again later.</fs-body-text
        >
        <fs-button
          class="refi-error-button"
          variant="primary"
          type="button"
          @click="${this.signOut}"
          >Okay</fs-button
        >
      </div>
    `;
  }

  signOut(ev) {
    ev.preventDefault();
    trackAnalyticsEvent(`refi-error`);
    document.dispatchEvent(new CustomEvent('refi-login-sign-out'));
  }
}

customElements.define('refi-error', RefiError);
